var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldHeartRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.68 13.908v-.01c-.88-.92-2.11-1.5-3.48-1.5-2.65 0-4.8 2.15-4.8 4.8 0 1.23.47 2.35 1.23 3.2.88.98 2.15 1.6 3.57 1.6 2.65 0 4.8-2.15 4.8-4.8 0-1.27-.5-2.42-1.31-3.28-.006 0-.01-.003-.01-.01zm-2.2 5.38c-.19 0-.38-.08-.53-.22l-.74-.74-.76.77c-.15.14-.34.22-.53.22-.1 0-.19-.02-.28-.06a.669.669 0 0 1-.25-.16c-.3-.3-.3-.77 0-1.06l.76-.77-.73-.74c-.3-.29-.3-.77 0-1.06.29-.29.76-.29 1.06 0l.73.74.71-.71c.3-.29.77-.29 1.06 0 .17.17.24.39.21.61-.01.17-.08.33-.21.45l-.71.71.74.74c.3.29.3.76 0 1.06-.14.14-.34.22-.53.22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.48 12.04c-.06.21-.31.27-.49.14a6.346 6.346 0 0 0-3.79-1.24c-3.47 0-6.3 2.83-6.3 6.3 0 1.08.28 2.14.81 3.08.16.28-.03.64-.33.53-2.41-.82-7.28-3.81-8.86-8.81C2.19 11.02 2 9.92 2 8.73c0-3.09 2.49-5.59 5.56-5.59 1.81 0 3.43.88 4.44 2.23a5.549 5.549 0 0 1 4.44-2.23c3.07 0 5.56 2.5 5.56 5.59 0 1.19-.19 2.29-.52 3.31z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldHeartRemove);
export default __webpack_public_path__ + "static/media/vuesax-bold-heart-remove.60c2d80f226efee2ae755a2d039f859a.svg";
export { ForwardRef as ReactComponent };